/**
 * Check if cpf is valid or not.
 * @param strCPF CPF String hyphen(-) or dot(.) is optional
 *
 *
 * @usage
 *   cpfIsValid('12345678909'); // -> true
 *
 *   cpfIsValid('123.456.789-09');  // -> true
 *
 *   cpfIsValid('23445898979');  // -> false
 *
 *   cpfIsValid('234.458.989-79');  // -> false
 */
export function cpfIsValid(strCPF: string): boolean {
  let Soma = 0;
  let Resto;
  strCPF = strCPF.replace(/\D/g, "");
  if (strCPF == "00000000000") return false;

  for (let i = 1; i <= 9; i++) {
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  }

  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) {
    Resto = 0;
  }

  if (Resto != parseInt(strCPF.substring(9, 10))) {
    return false;
  }

  Soma = 0;
  for (let i = 1; i <= 10; i++) {
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  }

  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) {
    Resto = 0;
  }

  if (Resto != parseInt(strCPF.substring(10, 11))) {
    return false;
  }

  return true;
}
